import React, { useMemo, useRef } from 'react';
import clsx from 'clsx';
import { Icons, Box, Stack, Typography } from "@curves/ui-base";
import { ListInfo } from '@icoach/accountBook/components';
import ScrollerArrowButton from '@icoach/inbody/components/ScrollerArrowButton';
import Tablenization from '@icoach/components/Tablenization';
import { parseDate } from '@util/moment';
import { MemberSecureCard } from '@icoach/components';
import usePrivacyToggle, { securityMaskFilterTypeMap } from '@util/hook/usePrivacyToggle';

const PointsProductGiftRecordTable = React.forwardRef((props, ref) => {
    const { pageSize = 10, pageIndex = 1, totalCount = 0, totalPage = 0, rowsData = [], onPageChange: onPageChangeProps } = props;
    const { isRevealed, toggle, renderPrivacyIcon } = usePrivacyToggle();
    const scrollerArrowRef = useRef(null);

    const handlePageChange = (e, num) => {
        onPageChangeProps(num);
    };

    const handleToggleRevealed = () => {
        const apiParams = {
            filterType: securityMaskFilterTypeMap.ClubPointsRedeemdOverview,
            totalCount: rowsData?.length,
        };
        toggle(apiParams);
    };

    const headerRow = useMemo(
        () => [
            {
                cellKey: 'orderDate',
                headerLabel: '建立日期',
                align: 'left',
                width: 18,
                maxWidth: 18,
                formatCell: (value, { orderNo }) => {
                    return (
                        <Stack direction="column">
                            <Typography component="span">{parseDate(value, 'YYYY/MM/DD HH:MM')}</Typography>
                            <Typography component="span">{orderNo}</Typography>
                        </Stack>
                    );
                },
            },
            {
                cellKey: 'displayName',
                headerLabel: '兌換人',
                align: 'center',
                width: 18,
                maxWidth: 18,
                formatCell: (displayName, { maskDisplayName, memberNo }, { isRevealed }) => {
                    return <MemberSecureCard name={displayName} maskName={maskDisplayName} memberNo={memberNo} isRevealed={isRevealed} />;
                },
            },
            {
                cellKey: 'redeemItemName',
                headerLabel: '贈品名',
                align: 'center',
                formatCell: (value) => {
                    return <Typography component="span">{value}</Typography>;
                },
            },
            {
                cellKey: 'quantity',
                headerLabel: '兌換數量',
                width: 10,
                maxWidth: 10,
                align: 'center',
                formatCell: (value) => {
                    return <Typography component="span">{value}</Typography>;
                },
            },
            {
                cellKey: 'redeemStatus',
                headerLabel: '已簽收',
                width: 10,
                maxWidth: 10,
                align: 'center',
                formatCell: (value) => {
                    return String(value) === '1' ? <Icons.Check color="success" /> : null;
                },
            },
        ],
        [],
    );

    return (
        <Box className="mt-4">
            <Stack>
                {renderPrivacyIcon(handleToggleRevealed)}
                <ListInfo className={clsx('ml-auto', 'mb-2')} pageSize={pageSize} pageIndex={pageIndex} totalCount={totalCount} isCurrentPageLastIndex />
            </Stack>
            <Box className={'scroll-arrow-container'}>
                <Tablenization
                    cardProps={{ className: 'theme-gray' }}
                    page={pageIndex}
                    count={totalPage}
                    onChange={handlePageChange}
                    tableContainerRef={scrollerArrowRef}
                    isPagination
                >
                    <Tablenization.TableRowHeader headerRow={headerRow} />
                    <Tablenization.TableRowBody headerRow={headerRow} rowsData={rowsData} isRevealed={isRevealed} />
                </Tablenization>
                <ScrollerArrowButton parentRef={scrollerArrowRef} />
            </Box>
        </Box>
    );
});

export default PointsProductGiftRecordTable;
